import { BaseFilterInput, FilterConfig } from "./types";

export class FilterConfigRegistry<T extends BaseFilterInput> {
  private configs = new Map<string, FilterConfig<T>>();

  register<U extends T>(config: FilterConfig<U>): void {
    this.configs.set(config.id, config as unknown as FilterConfig<T>);
  }

  get(configId: string): FilterConfig<T> | undefined {
    return this.configs.get(configId);
  }

  getAll(): FilterConfig<T>[] {
    return Array.from(this.configs.values());
  }

  createDefault(configId: string): T {
    const config = this.get(configId);
    if (!config) {
      throw new Error(`No filter config registered for id: ${configId}`);
    }
    return config.createDefault();
  }

  validate(filter: T): boolean {
    const config = this.get(filter.configId);
    if (!config) {
      return false;
    }
    return config.validate(filter);
  }

  handleOperationChange(filter: T, newOperation: T["operation"]): Partial<T> {
    const config = this.get(filter.configId);
    if (!config) {
      return {};
    }
    return config.handleOperationChange(filter, newOperation);
  }

  hydrateFilter(apiFilter: Omit<T, "configId">): T {
    if ("propertyId" in apiFilter) {
      const configId = `${apiFilter.type}:${(apiFilter as { propertyId: string }).propertyId}`;
      return { ...apiFilter, configId } as unknown as T;
    }
    return { ...apiFilter, configId: apiFilter.type } as T;
  }
}
